import { render, staticRenderFns } from "./TutorialButton.vue?vue&type=template&id=080efc02"
import script from "./TutorialButton.vue?vue&type=script&lang=js"
export * from "./TutorialButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports